import React from "react";
import MemberIcon from '@rsuite/icons/Member';
import { Button, Drawer } from "rsuite";
import Header from "./../../components/Header";
import EntradaSaidaCarros from "./../../components/entradaSaidaCarros";
import Vans from "./../../components/vans";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  allClientes,
  updateCliente,
  filterClientes,
  filterClientesCnh,
  addClientes,
  unlinkClientes,
  resetClientes,
  sessionLogOut,
  updateDataCliente,
} from "../../store/modules/cliente/actions";
import { updateReservaCarro } from "../../store/modules/reservaCarro/actions";

export default function ReservaCarro() {
  const [reserva, setReserva] = useState(true);

  const dispatch = useDispatch();
  const { clientes, behavior, form, components, cliente, auth, users_licenses } = useSelector(
    (state) => state.cliente
  );
  var tokenAuto = sessionStorage.getItem("token");
  var SesId = sessionStorage.getItem("id");
  var SesNome = sessionStorage.getItem("name");
  var SesEmail = sessionStorage.getItem("email");
  var SesAtive = sessionStorage.getItem("active");

  let navigate = useNavigate();

  const setComponent = (component, state) => {
    dispatch(
      updateCliente({
        components: { ...components, [component]: state },
      })
    );
  };

  const setCliente = (key, value) => {
    dispatch(
      updateCliente({
        cliente: { ...cliente, [key]: value },
      })
    );
  };

  const logOut = () => {
    dispatch(updateReservaCarro({
      reservaCarrosCliente:  [],
    }));
    dispatch(sessionLogOut());
    navigate("/");
  };

  const CadastrarCNH = () => {
  
    navigate("/clientes/cnh");
  };

  const openHistoryClient = () => {
    setComponent("drawer", true);
  };

  useEffect(() => {
    dispatch(filterClientes());
   // dispatch(filterClientesCnh())
  }, []);


  return (
    <>
      <div className="d-flex flex-column col-xl-12 col-12 col-sm-12 p-0 bg-dark ">
        <button className="m-0 p-0" onClick={openHistoryClient}>
          <Header name={cliente.name} email={SesEmail} />
        </button>
        <Drawer
          open={components.drawer}
          size="full"
          placement="top"
          onClose={() => setComponent("drawer", false)}
        >
          <Drawer.Body>
            <h3>Cliente</h3>

            <div className="input-group-append d-flex flex-column  col-12 align-content-center">
              <div className="input-group-append">
                <div className="form-group col-12 mt-2">
                  <b className="">Nome</b>
                  <input
                    type="text"
                    className="form-control mt-2"
                    placeholder="Name"
                    disabled={form.disabled}
                    value={cliente.name}
                  />
                </div>
                <div className="form-group col-12 mt-2 ">
                  <b className="">E-mail</b>
                  <input
                    type="text"
                    className="form-control mt-2"
                    placeholder="Email"
                    disabled="{form.disabled}"
                    value={cliente.email}
                  />
                </div>
                <div className="form-group col-12 mt-2 ">
                  <b className="">Ativo</b>
                  <input
                    type="text"
                    className="form-control mt-2"
                    placeholder="Ativo"
                    disabled={form.disabled}
                    value={cliente.active ? "Ativo" : "Não ATIVO"}
                  />
                </div>
                <div className="form-group col-12 mt-2 ">
                  <b className="">Endereço</b>
                  <input
                    type="text"
                    className="form-control mt-2"
                    placeholder="Address"
                    value={cliente.address}
                    onChange={(e) => setCliente("address", e.target.value)}
                  />
                </div>
                <div className="form-group col-12 mt-2 ">
                  <b className="">Número</b>
                  <input
                    type="text"
                    className="form-control mt-2"
                    placeholder="Numero de enderço"
                    value={cliente.address_number}
                    onChange={(e) =>
                      setCliente("address_number", e.target.value)
                    }
                  />
                </div>
                <div className="form-group col-12 mt-2 ">
                  <b className="">Complemento</b>
                  <input
                    type="text"
                    className="form-control mt-2"
                    placeholder="Complemento"
                    value={cliente.address_complement}
                    onChange={(e) =>
                      setCliente("address_complement", e.target.value)
                    }
                  />
                </div>
                <div className="form-group col-12 mt-2 ">
                  <b className="">Bairro</b>
                  <input
                    type="text"
                    className="form-control mt-2"
                    placeholder="Distrito"
                    value={cliente.address_district}
                    onChange={(e) =>
                      setCliente("address_district", e.target.value)
                    }
                  />
                </div>
                <div className="form-group col-12 mt-2 ">
                  <b className="">Cidade</b>
                  <input
                    type="text"
                    className="form-control mt-2"
                    placeholder="Ciudade"
                    value={cliente.address_city}
                    onChange={(e) => setCliente("address_city", e.target.value)}
                  />
                </div>
                <div className="form-group col-12 mt-2 ">
                  <b className="">Estado</b>
                  <input
                    type="text"
                    className="form-control mt-2"
                    placeholder="Estado"
                    value={cliente.address_state}
                    onChange={(e) =>
                      setCliente("address_state", e.target.value)
                    }
                  />
                </div>
                <div className="form-group col-12 mt-2 ">
                  <b className="">CEP</b>
                  <input
                    type="text"
                    className="form-control mt-2"
                    placeholder="Cep"
                    value={cliente.address_zipcode}
                    onChange={(e) =>
                      setCliente("address_zipcode", e.target.value)
                    }
                  />
                </div>
                <div className="form-group col-12 mt-2  ">
                  <b className="">CNH</b>
                   
                  { !users_licenses.id?
                  <div className="d-flex p-1 justify-content-between ">

                  <b>Sem CNH cadastrada</b>
                     <button                     
                     className="p-2 col-2 btn btn-outline-success"                 
                     loading={form.saving}
                     onClick={()=>{CadastrarCNH()}}
                   >
                     <MemberIcon/>
                   </button>
                   </div>
                    : 
                    <div>
                    {users_licenses.map((licencia) => {
                      <div className="form-group col-12 mt-2 ">
                        <b className="">CNH</b>
                        <input
                          type="img"
                          className="form-control mt-2"
                          placeholder="Cep"
                          src={`data:image/png;base64,${licencia.photo}`}
                          value={`data:image/png;base64,${licencia.photo}`}
                          onChange={(e) =>
                            setCliente("photo", e.target.value)
                          }
                        />
                      </div>;
                      <div className="form-group col-12 mt-2 ">
                        <b className="">Numero</b>
                        <input
                          type="text"
                          className="form-control mt-2"
                          placeholder="Numero"
                          value={licencia.number}
                          onChange={(e) =>
                            setCliente("address_zipcode", e.target.value)
                          }
                        />
                      </div>;
                      <div className="form-group col-12 mt-2 ">
                        <b className="">Validade</b>
                        <input
                          type="text"
                          className="form-control mt-2"
                          placeholder="Validade"
                          value={licencia.valid_to}
                          onChange={(e) =>
                            setCliente("valid_to", e.target.value)
                          }
                        />
                      </div>;
                      <div className="form-group col-12 mt-2 ">
                        <b className="">Categoria</b>
                        <input
                          type="text"
                          className="form-control mt-2"
                          placeholder="categoria"
                          value={licencia.category}
                          onChange={(e) =>
                            setCliente("category", e.target.value)
                          }
                        />
                      </div>;
                      <div className="form-group col-12 mt-2 ">
                        <b className="">Ativa</b>
                        <input
                          type="text"
                          className="form-control mt-2"
                          placeholder="Ativa"
                          value={licencia.active}
                          onChange={(e) =>
                            setCliente("active", e.target.value)
                          }
                        />
                      </div>
                    })}
                      </div>
                  
                  
                  }
                
                </div>
              </div>
            </div>

            <Button
              block
              appearance="primary"
              className=" mt-3"
              color="green"
              size="lg"
              loading={form.saving}
              onClick={() => dispatch(updateDataCliente())}
            >
              Atualizar Dados
            </Button>
            <Button
              block
              appearance="primary"
              className=" mt-3"
              color={behavior === "reservar" ? "green" : "red"}
              size="lg"
              loading={form.saving}
              onClick={() => logOut()}
            >
              Sair
            </Button>
          </Drawer.Body>
        </Drawer>

        <div className=" d-flex align-items-center row  ">
          <header className=" d-flex row  bg-dark  p-0 m-0 ">
            <div className=" d-flex    col-xl-12 col-12 col-sm-12  justify-content-between p-0 m-2">
              <div className="d-flex row col-6   align-items-center   ">
                <Button
                  appearance="primary"
                  onClick={() => setReserva(true)}
                  className="container-fluid d-flex col-8 text-center"
                >
                  <b className=" text-white  col-12 text-center   ">Aluguel</b>
                </Button>
              </div>
              <div className="container-fluid d-flex col-6">
                <Button
                  appearance="primary"
                  className="container-fluid d-flex col-8  text-center "
                  onClick={() => setReserva(false)}
                >
                  <b className="col-12 text-white "> Vans</b>
                </Button>
              </div>
            </div>
          </header>
        </div>
        {reserva ? (
          <EntradaSaidaCarros key="EntradaSaidaCarros01" />
        ) : (
          <Vans key="VansVans01" />
        )}
      </div>
    </>
  );
}
